import { render } from "./PolishLanguage.vue?vue&type=template&id=0177aa70"
import script from "./PolishLanguage.vue?vue&type=script&lang=js"
export * from "./PolishLanguage.vue?vue&type=script&lang=js"

import exportComponent from "/builds/ser-kso/new-claim-form/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__